import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCashReceiptsQueryVariables = Types.Exact<{
  dateFrom: Types.Scalars['DateTime']['input'];
  dateTo: Types.Scalars['DateTime']['input'];
  first: Types.Scalars['Int']['input'];
}>;


export type GetCashReceiptsQuery = { __typename?: 'Query', reportCashReceiptsData: { __typename?: 'ReportCashReceiptsDataPayload', totalCount: number, totalMatching: number, data: Array<{ __typename?: 'ReportCashReceiptsDataRow', receivedDate: Types.TDateISO, paymentMethod: string, amount: number, daysToPay: number, lateChargeAssessed: number, invoiceNumber: string, customerId: string }> } };

export type GetCustomerAvgDaysToPayQueryVariables = Types.Exact<{
  periodAFrom: Types.Scalars['DateTime']['input'];
  periodATo: Types.Scalars['DateTime']['input'];
  periodBFrom: Types.Scalars['DateTime']['input'];
  periodBTo: Types.Scalars['DateTime']['input'];
  first: Types.Scalars['Int']['input'];
}>;


export type GetCustomerAvgDaysToPayQuery = { __typename?: 'Query', reportCustomerAvgDaysToPayData: { __typename?: 'ReportCustomerAvgDaysToPayDataPayload', totalCount: number, totalMatching: number, data: Array<{ __typename?: 'ReportCustomerAvgDaysToPayDataRow', customerId: string, customerName: string, periodAAverageDays?: number | null, periodAPaymentCount: number, periodBAverageDays?: number | null, periodBPaymentCount: number, periodBLabel: string }> } };

export type GetCustomerSalesPaymentsCreditsQueryVariables = Types.Exact<{
  dateFrom: Types.Scalars['DateTime']['input'];
  dateTo: Types.Scalars['DateTime']['input'];
  first: Types.Scalars['Int']['input'];
}>;


export type GetCustomerSalesPaymentsCreditsQuery = { __typename?: 'Query', reportCustomerSalesPaymentsCreditsData: { __typename?: 'ReportCustomerSalesPaymentsCreditsDataPayload', totalCount: number, totalMatching: number, data: Array<{ __typename?: 'ReportCustomerSalesPaymentsCreditsDataRow', customerId: string, customerName: string, salesTotal: number, paymentsTotal: number, creditsTotal: number, netActivity: number, discountsTaken: number, lateChargesAssessed: number }> } };


export const GetCashReceiptsDocument = new TypedDocumentString(`
    query GetCashReceipts($dateFrom: DateTime!, $dateTo: DateTime!, $first: Int!) {
  reportCashReceiptsData(dateFrom: $dateFrom, dateTo: $dateTo, first: $first) {
    totalCount
    totalMatching
    data {
      receivedDate
      paymentMethod
      amount
      daysToPay
      lateChargeAssessed
      invoiceNumber
      customerId
    }
  }
}
    `);
export const GetCustomerAvgDaysToPayDocument = new TypedDocumentString(`
    query GetCustomerAvgDaysToPay($periodAFrom: DateTime!, $periodATo: DateTime!, $periodBFrom: DateTime!, $periodBTo: DateTime!, $first: Int!) {
  reportCustomerAvgDaysToPayData(
    periodAFrom: $periodAFrom
    periodATo: $periodATo
    periodBFrom: $periodBFrom
    periodBTo: $periodBTo
    first: $first
  ) {
    totalCount
    totalMatching
    data {
      customerId
      customerName
      periodAAverageDays
      periodAPaymentCount
      periodBAverageDays
      periodBPaymentCount
      periodBLabel
    }
  }
}
    `);
export const GetCustomerSalesPaymentsCreditsDocument = new TypedDocumentString(`
    query GetCustomerSalesPaymentsCredits($dateFrom: DateTime!, $dateTo: DateTime!, $first: Int!) {
  reportCustomerSalesPaymentsCreditsData(
    dateFrom: $dateFrom
    dateTo: $dateTo
    first: $first
  ) {
    totalCount
    totalMatching
    data {
      customerId
      customerName
      salesTotal
      paymentsTotal
      creditsTotal
      netActivity
      discountsTaken
      lateChargesAssessed
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCashReceipts: build.query<GetCashReceiptsQuery, GetCashReceiptsQueryVariables>({
      query: (variables) => ({ document: GetCashReceiptsDocument, variables })
    }),
    GetCustomerAvgDaysToPay: build.query<GetCustomerAvgDaysToPayQuery, GetCustomerAvgDaysToPayQueryVariables>({
      query: (variables) => ({ document: GetCustomerAvgDaysToPayDocument, variables })
    }),
    GetCustomerSalesPaymentsCredits: build.query<GetCustomerSalesPaymentsCreditsQuery, GetCustomerSalesPaymentsCreditsQueryVariables>({
      query: (variables) => ({ document: GetCustomerSalesPaymentsCreditsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCashReceiptsQuery, useLazyGetCashReceiptsQuery, useGetCustomerAvgDaysToPayQuery, useLazyGetCustomerAvgDaysToPayQuery, useGetCustomerSalesPaymentsCreditsQuery, useLazyGetCustomerSalesPaymentsCreditsQuery } = injectedRtkApi;
